<ng-container *transloco="let t; read: 'expenses'">
  <h1 class="mbm">{{ t('title') }}</h1>

  <kendo-tabstrip *ngIf="ready">
    <kendo-tabstrip-tab [title]="t('ownTab')" [selected]="true">
      <ng-template kendoTabContent>
        <app-expense-list mode="own"></app-expense-list>
      </ng-template>
    </kendo-tabstrip-tab>

    <!-- Supervisor review of submitted expenses -->
    <kendo-tabstrip-tab *ngIf="canReview">
      <ng-template kendoTabTitle>
        {{ t('reviewTab') }}
        <span *ngIf="(reviewCount$ | async) as reviewCount" class="count-circle mls">
          {{ reviewCount }}
        </span>
      </ng-template>
      <ng-template kendoTabContent>
        <app-expense-list mode="approval"></app-expense-list>
      </ng-template>
    </kendo-tabstrip-tab>

    <!-- Accounting payment run: accepted/paid expenses of all employees, export, bulk mark paid -->
    <kendo-tabstrip-tab *ngIf="hasAccounting" [title]="t('accountingTab')">
      <ng-template kendoTabContent>
        <app-expense-accounting-list></app-expense-accounting-list>
      </ng-template>
    </kendo-tabstrip-tab>

    <kendo-tabstrip-tab *ngIf="canReview" [title]="t('processedTab')">
      <ng-template kendoTabContent>
        <!-- Re-deciding from the dialog needs a reviewer function; a pure accounting user only reads. -->
        <app-expense-processed-list [allowReprocess]="canReview"></app-expense-processed-list>
      </ng-template>
    </kendo-tabstrip-tab>
  </kendo-tabstrip>
</ng-container>
